import React from 'react';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonSmallText from '../../../common-components/common-small-text';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const GgeNumbers = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper className="gge-numbers">
                <CommonSmallTitle>
                    <div className="gge-numbers__link gge__link" href="#">
                        ФАУ &laquo;Главгосэкспертиза России&raquo;
                    </div>
                </CommonSmallTitle>
                <CommonSmallText className="gge-numbers__info">
                    Это современное государственное учреждение в&nbsp;строительной отрасли, которое
                    осуществляет экспертизу и&nbsp;надзор над ключевыми инфраструктурными объектами
                    страны.
                </CommonSmallText>
                <CommonSmallTitle className="gge-numbers__subtitle">
                    Учреждение в цифрах
                </CommonSmallTitle>
                <div className="gge-numbers__items">
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={50}
                        animateOnce={true}
                        duration={1}
                        className="gge-numbers__item-body"
                    >
                        <div className="gge-numbers__item-title">22</div>
                        <CommonSmallText className="gge-numbers__item-subtitle">
                            Структурных подразделения
                        </CommonSmallText>
                    </ScrollAnimation>
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={50}
                        animateOnce={true}
                        duration={1}
                        className="gge-numbers__item-body"
                    >
                        <div className="gens-numbers__item-title">12</div>
                        <CommonSmallText className="gens-numbers__item-subtitle">
                            Филиалов
                        </CommonSmallText>
                    </ScrollAnimation>
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={50}
                        animateOnce={true}
                        duration={1}
                        className="gge-numbers__item-body"
                    >
                        <div className="gge-numbers__item-title">1354</div>
                        <CommonSmallText className="gge-numbers__item-subtitle">
                            Сотрудника
                        </CommonSmallText>
                    </ScrollAnimation>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default GgeNumbers;
